import { useContext, useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router";
import { loadOrgRecords } from "../api/connection";
import { PageContext } from "../contexts/PageContext";
import { RemoteControl } from "../models/RemoteControl";
import { CheckBox, Close, GamepadTwoTone, GroupAdd, RefreshRounded } from "@mui/icons-material";
import { CssBaseline, Backdrop, CircularProgress, TableContainer, TableHead, TableRow, TableCell, TableBody, Box, Table, Link, Typography } from "@mui/material";
import Minibar from "../components/Minibar";
import PageHeader from "../components/PageHeader";

export function Remotes() {
  const { isLoggedIn, user } = useContext(PageContext);
  const navigate = useNavigate();
  const [filteredRows, setFilteredRows] = useState<RemoteControl[]>([]);
  const hasRunLoader = useRef<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  useEffect(() => {
    // console.log('Component mounted, isLoggedIn:', isLoggedIn);
    if (!isLoggedIn) {
      navigate("/");
      return;
    }

    const fetchRemotes = async () => {
      try {
        const res = await loadOrgRecords<RemoteControl>("remotecontrols");
        const sortedRemotes = res.sort((a, b) => a.name.localeCompare(b.name));
        setFilteredRows(sortedRemotes);
      } catch (err) {
        console.error("Failed to fetch remote controls:", err);
      } finally {
        setLoading(false);
      }
    };
    if (isLoggedIn && user) {
      fetchRemotes();
    }
    // return () => {
    //   console.log('Component unmounted');
    // };
  }, [isLoggedIn, navigate, isLoggedIn, user]);    

  return (
      <Box sx={{ display: "flex" }}>
        <CssBaseline />

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 0,
            m: 0,
            backgroundColor: "#212121",
            color: "#ECECEC",
            minHeight: "100vh",
          }}
        >
          <Backdrop
            open={loading}
            sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
          >
            <CircularProgress color="inherit" />
          </Backdrop>

          <PageHeader
            title={"Remotes"}
            rightComponent={[
              <Minibar
                minibarItems={[
                  {
                    text: "Add Remote",
                    icon: <GamepadTwoTone />,
                    nav: `/edit-remote/new`,
                  }
                ]}
                barLength={1}
              />,
            ]}
          />
          <TableContainer sx={{ maxWidth: 1200, maxHeight: '80vh', mt: 2, mb: 4, mx: 2, borderRadius: 2, backgroundColor: "#303030" }}> 
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="left" width="20%">
                    Name
                  </TableCell>
                  <TableCell align="left" width="20%">
                    Serial Number
                  </TableCell>
                  <TableCell align="left" width="20%">
                    Updated
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredRows.map((remote) => (
                  <TableRow hover key={remote._id}>
                    <TableCell align="left">
                      <Link
                        onClick={() => navigate(`/edit-remote/${remote._id}`)}
                        style={{ color: "#b0d1ff", cursor: "pointer" }}>
                        {remote.name}
                      </Link>
                    </TableCell>
                    <TableCell align="left">{remote.serialNumber}</TableCell>
                    <TableCell align="left">
                      {remote.deploymentPackStamp && remote.deploymentPackStampOnDevice === remote.deploymentPackStamp ? (
                        <CheckBox />
                      ) : (
                        <Typography variant="body2" color="error">
                          <Close style={{ verticalAlign: 'middle', marginRight: 4 }} />
                          Last updated: {remote.deploymentPackStampOnDevice ? new Date(remote.deploymentPackStampOnDevice).toLocaleString() : 'Never'}  
                        </Typography>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
  );
}